import React, { useState } from 'react';

import { useAsyncInit } from '@hooks';
import type { ISoundCloudWidgetProps } from './SoundCloudWidget';

const O_EMBED_SOUND_CLOUD_URL = 'https://soundcloud.com/oembed';

// eslint-disable-next-line @typescript-eslint/naming-convention
interface IOEmbedResponse {
  version: number;
  type: string;
  height: number;
  width: string;
  title: string;
  description: string;
  html: string;
  /* eslint-disable @typescript-eslint/naming-convention */
  provider_name: string;
  thumbnail_url: string;
  provider_url: string;
  author_name: string;
  author_url: string;
  /* eslint-enable @typescript-eslint/naming-convention */
}

export function SoundCloudWidget({
  width,
  height,
  visual,
  url,
}: ISoundCloudWidgetProps) {
  const [src, setSrc] = useState('');

  useAsyncInit(async () => {
    try {
      const oEmbedUrl = new URL(O_EMBED_SOUND_CLOUD_URL);
      oEmbedUrl.searchParams.set('url', url);

      const res: IOEmbedResponse = await fetch(oEmbedUrl.toString(), {
        method: 'GET',
      }).then((r) => r.json());

      const matchedSrc = res.html.match(/src="([^"]+)"/);

      const widgetSrc = matchedSrc ? matchedSrc[1] : null;

      if (widgetSrc) {
        const parsedWidgetSrc = new URL(widgetSrc);

        parsedWidgetSrc.searchParams.set('auto_play', String(false));
        parsedWidgetSrc.searchParams.set('buying', String(false));
        parsedWidgetSrc.searchParams.set('download', String(false));
        parsedWidgetSrc.searchParams.set('sharing', String(false));
        parsedWidgetSrc.searchParams.set(
          'single_active',
          String(false),
        );
        parsedWidgetSrc.searchParams.set('visual', String(visual));

        setSrc(parsedWidgetSrc.toString());
      }
    } catch (error) {
      // Do nothing
    }
  }, [url, visual]);

  return (
    <iframe
      width={width}
      height={height}
      scrolling="no"
      frameBorder="no"
      allow="autoplay"
      src={src}
    />
  );
}
